








































/**
 * This component is designed to abstract some of the common features away when building a mobile friendly version
 * of a row component.
 *
 * Props
 * index - the row index from the parent
 * item - the row data object
 * cols - an object with type Column[] describing the columns that are shown on mobile (not including collapsed content)
 * orderBy - column to order by, must exist in cols
 * ascDesc - order direction
 * toggleOrder - function to switch the ordering of rows
 *
 *
 * Slots
 * cell - each cell will go into one of these slots.  The styling of the cell is controlled by the parent
 *
 * actions - any actions beyond the row toggle need to be added here. The styling and logic are controlled by the parent
 *
 * collapse-data - the row information that is concealed by the collapsible button lives here. Again styling controlled
 *  by the parent
 *
 **/

  import {Component, Vue, Prop} from "vue-property-decorator";
  import ExpandButton from "@/components/ExpandButton.vue";
  import { Column } from "@/types";

  @Component({
    components: {
      ExpandButton
    }
  })
  export default class MobileFriendlyRow extends Vue {

    @Prop({ default: 0,  type: Number}) index!: number;
    @Prop({ default: () => {},  type: Object}) item!: object;
    @Prop({ default: () => [], type: Array}) cols!: Column[];
    @Prop({ type: String}) orderBy!: string;
    @Prop({ default: 'asc',  type: String}) ascDesc!: 'asc'|'desc';
    @Prop({type:Function}) toggleOrder!: () => void
    @Prop({default: true, type: Boolean}) banded?: boolean

    expand:boolean = false;

  }

